import React from "react";

/** Inline validation message shown directly under the related input. */
function CmsFieldError({ id, message }) {
  if (!message) return null;

  return (
    <div id={id} className="cms-field-error" role="alert">
      <i className="mdi mdi-alert-circle-outline" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}

export default CmsFieldError;
